"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extractDate = _interopRequireDefault(require("./extractDate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable filenames/match-exported */
var _default = _extractDate.default;
exports.default = _default;
//# sourceMappingURL=index.js.map